export const YourSalesTypes = {
  IGetYourSalesService: Symbol("IGetYourSalesService"),
};
